import { ADDRESS_PATHS, type SavedAddress } from '../constants/addresses'

export function upsertSavedAddress(
  current: SavedAddress[] | undefined,
  next: SavedAddress,
): SavedAddress[] {
  const list = current ?? []
  const index = list.findIndex((address) => address.id === next.id)
  if (index < 0) return [next, ...list]
  return list.map((address) => (address.id === next.id ? next : address))
}

export function removeSavedAddress(
  current: SavedAddress[] | undefined,
  id: string,
): SavedAddress[] {
  return (current ?? []).filter((address) => address.id !== id)
}

export function readAddressEditReturn(state: unknown): string {
  if (!state || typeof state !== 'object' || !('returnTo' in state)) {
    return ADDRESS_PATHS.list
  }
  const returnTo = (state as { returnTo?: unknown }).returnTo
  if (typeof returnTo === 'string' && returnTo.startsWith('/')) return returnTo
  return ADDRESS_PATHS.list
}
